import { render, staticRenderFns } from "./NoText.vue?vue&type=template&id=a2d72d0a&scoped=true&"
import script from "./NoText.vue?vue&type=script&lang=ts&"
export * from "./NoText.vue?vue&type=script&lang=ts&"
import style0 from "./NoText.vue?vue&type=style&index=0&id=a2d72d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d72d0a",
  null
  
)

export default component.exports